module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "lefth1"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('i', [_vm._v("Our world in stupor lies;")])])])]), _vm._v(" "), _c('p', {
    staticClass: "lefth"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Yet, dotted everywhere,")])])]), _vm._v(" "), _c('p', {
    staticClass: "lefth"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Ironic points of light")])])]), _vm._v(" "), _c('p', {
    staticClass: "lefth"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Flash out wherever the Just")])])]), _vm._v(" "), _c('p', {
    staticClass: "lefth"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Exchange their messages")])])]), _vm._v(" "), _c('p', {
    staticClass: "lefth-ts"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("— W. H. Auden, “September 1, 1939”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610bbe76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Frontmatter1.vue
// module id = 75
// module chunks = 0